import { __extends, __assign, __rest } from 'tslib';
import { createElement, Component, Children, isValidElement, cloneElement } from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import styles from './uitk-images.css';

// Image Fit Types
var UitkImageFitMap = [
    ['cover', 'all-image-fit-cover'],
    ['contain', 'all-image-fit-contain']
];
var UitkImageFits = new Map(UitkImageFitMap);
// Roundcorner Types
var UitkRoundcornerPropMap = [
    ['all', 'all'],
    ['max', 'max'],
    ['startstart', 'startstart'],
    ['startend', 'startend'],
    ['endstart', 'endstart'],
    ['endend', 'endend']
];
var UitkRoundcorners = new Map(UitkRoundcornerPropMap);

var getClassNameList = classNames.bind(styles);
var UitkFigureAspectRatioType;
(function (UitkFigureAspectRatioType) {
    UitkFigureAspectRatioType["R1_1"] = "ratio-1-1";
    UitkFigureAspectRatioType["R4_3"] = "ratio-4-3";
    UitkFigureAspectRatioType["R3_2"] = "ratio-3-2";
    UitkFigureAspectRatioType["R16_9"] = "ratio-16-9";
    UitkFigureAspectRatioType["R21_9"] = "ratio-21-9";
    UitkFigureAspectRatioType["R3_4"] = "ratio-3-4";
})(UitkFigureAspectRatioType || (UitkFigureAspectRatioType = {}));
var UitkFigure = /** @class */ (function (_super) {
    __extends(UitkFigure, _super);
    function UitkFigure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkFigure.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, children = _b.children, ratio = _b.ratio, src = _b.src, roundcorner = _b.roundcorner, imageFit = _b.imageFit, additionalProps = _b.additionalProps, style = _b.style;
        var Tag = src ? 'div' : 'figure';
        var handleRoundcornerClassArray = function (classArr, propArr, baseClass) {
            propArr.forEach(function (arrayValue) {
                return classArr.push(baseClass + "-" + UitkRoundcorners.get(arrayValue));
            });
        };
        var roundcornerClass = function (prop) {
            var roundcornerBaseClass = 'uitk-image-roundcorner';
            var propType = typeof prop;
            var classArr = [];
            var propIsArray = Array.isArray(prop);
            if (propType === 'boolean') {
                // Prop type is boolean
                classArr.push(roundcornerBaseClass + "-all");
            }
            else if (propIsArray) {
                // Prop type is array
                handleRoundcornerClassArray(classArr, prop, roundcornerBaseClass);
            }
            else {
                // Prop type is object
                var object_1 = prop;
                Object.getOwnPropertyNames(object_1).forEach(function (breakpointKey) {
                    var breakRoundcornerBaseClass = roundcornerBaseClass + "-" + breakpointKey;
                    if (Array.isArray(object_1[breakpointKey])) {
                        handleRoundcornerClassArray(classArr, object_1[breakpointKey], breakRoundcornerBaseClass);
                    }
                    else {
                        // UitkRoundcornerBreakSetting type
                        var cornerObject_1 = object_1[breakpointKey];
                        Object.getOwnPropertyNames(cornerObject_1).forEach(function (cornerKey) {
                            if (cornerObject_1[cornerKey] === 'set') {
                                classArr.push(breakRoundcornerBaseClass + "-" + UitkRoundcorners.get(cornerKey));
                            }
                            else if (cornerObject_1[cornerKey] === 'unset')
                                classArr.push(breakRoundcornerBaseClass + "-" + UitkRoundcorners.get(cornerKey) + "-unset");
                        });
                    }
                });
            }
            return classArr;
        };
        var classList = getClassNameList('uitk-image', className, roundcorner && roundcornerClass(roundcorner), imageFit && UitkImageFits.get(imageFit), (_a = {},
            _a["" + ratio] = validatePropType(ratio, UitkFigureAspectRatioType),
            _a['uitk-image-background'] = src,
            _a));
        var cssStyle = {};
        if (style) {
            cssStyle = style;
        }
        else if (src) {
            cssStyle = { backgroundImage: "url(\"" + src + "\")" };
        }
        var newProps = __assign({ className: classList, style: cssStyle }, additionalProps);
        return createElement(Tag, __assign({}, newProps), children);
    };
    UitkFigure.displayName = 'UitkFigure';
    UitkFigure.AspectRatio = UitkFigureAspectRatioType;
    return UitkFigure;
}(Component));

var getClassNameList$1 = classNames.bind(styles);
var UitkImage = /** @class */ (function (_super) {
    __extends(UitkImage, _super);
    function UitkImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hideImage: false
        };
        _this.handleError = _this.handleError.bind(_this);
        return _this;
    }
    UitkImage.prototype.shouldComponentUpdate = function (nextProps) {
        var hideImage = this.state.hideImage;
        if (nextProps.src && hideImage === true) {
            // This manually triggers an update and then forces a false to prevent a loop
            this.setState({
                hideImage: false
            });
            return false;
        }
        return true;
    };
    UitkImage.prototype.handleError = function (event) {
        var _a = this.props, blankDefault = _a.blankDefault, placeholderImage = _a.placeholderImage, additionalProps = _a.additionalProps;
        this.setState({
            hideImage: !!placeholderImage || !!blankDefault
        });
        if (additionalProps) {
            // To get around TypeScript error "Property does not exist on type object"
            var castedProps = additionalProps;
            if (castedProps.onError && typeof castedProps.onError === 'function') {
                castedProps.onError(event);
            }
        }
    };
    UitkImage.prototype.render = function () {
        var _a;
        var _b = this.props, blankDefault = _b.blankDefault, className = _b.className, placeholderImage = _b.placeholderImage, alt = _b.alt, src = _b.src, imgRef = _b.imgRef, additionalProps = _b.additionalProps;
        var hideImage = this.state.hideImage;
        var imageClasses = getClassNameList$1('uitk-image-media', className);
        var placeholderClass = getClassNameList$1('uitk-image-placeholder', (_a = {},
            _a["uitk-image-placeholder-image"] = placeholderImage && !blankDefault,
            _a));
        var imageProps = __assign({ className: imageClasses, ref: imgRef, src: src }, additionalProps);
        return (createElement("div", { className: placeholderClass }, !hideImage && createElement("img", __assign({ alt: alt }, imageProps, { onError: this.handleError }))));
    };
    UitkImage.displayName = 'UitkImage';
    UitkImage.defaultProps = {
        blankDefault: false,
        src: ''
    };
    return UitkImage;
}(Component));

var LimitedStringSet = /** @class */ (function () {
    function LimitedStringSet(maxSize) {
        if (maxSize === void 0) { maxSize = 100; }
        this._size = 0;
        this.data = {};
        this.maxSize = maxSize;
    }
    LimitedStringSet.prototype.add = function (value) {
        if (this.has(value)) {
            return;
        }
        if (this.length >= this.maxSize) {
            this.removeFirst();
        }
        this.data[value] = true;
        this._size += 1;
    };
    LimitedStringSet.prototype.remove = function (value) {
        if (this.data[value]) {
            delete this.data[value];
            this._size -= 1;
        }
    };
    LimitedStringSet.prototype.removeFirst = function () {
        for (var value in this.data) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.data.hasOwnProperty(value)) {
                delete this.data[value];
                this._size -= 1;
                break;
            }
        }
    };
    LimitedStringSet.prototype.has = function (value) {
        return Boolean(this.data[value]);
    };
    Object.defineProperty(LimitedStringSet.prototype, "length", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    return LimitedStringSet;
}());

var MAX_SET_SIZE = 100;
/**
 * ImageQueue Notes:
 * - Does not handle duplicate entries any differently. (LOC to ROI is very poor)
 */
var ImageQueue = /** @class */ (function () {
    function ImageQueue(_a) {
        var maxConnections = (_a === void 0 ? { maxConnections: 3 } : _a).maxConnections;
        this.reset();
        this.maxConnections = maxConnections;
    }
    ImageQueue.prototype.reset = function () {
        this.queue = [];
        this.runners = [];
        this.completedUrls = new LimitedStringSet(MAX_SET_SIZE);
    };
    /*
      Source = string identifier, eg: 'hsr'
      imageUrl (required) = image to download
      imgRef = ref to an existing Image to load image to
      callback = (error) => {}
     */
    ImageQueue.prototype.enqueue = function (_a) {
        var source = _a.source, imageUrl = _a.imageUrl, imgRef = _a.imgRef, callback = _a.callback;
        this.queue.push({ source: source, imageUrl: imageUrl, imgRef: imgRef, callback: callback });
        if (this.runners.length < this.maxConnections) {
            this._loadImages();
        }
    };
    ImageQueue.prototype.dequeue = function (imageUrl, source) {
        this.queue = this.queue.filter(function (item) { return !(item.imageUrl === imageUrl && (!source || item.source === source)); } // Easier to reason about !(dequeueMatch) for filtering
        );
    };
    ImageQueue.prototype.dequeueAll = function (source) {
        this.queue = this.queue.filter(function (item) { return item.source !== source; });
    };
    ImageQueue.prototype._loadImages = function () {
        var _this = this;
        this.queue.splice(0, this.maxConnections - this.runners.length).forEach(function (task) {
            _this._downloadImage(task);
        });
    };
    ImageQueue.prototype._downloadImage = function (task) {
        var _this = this;
        var image = task.imgRef || new Image();
        var handler = function (error) { return function () {
            var index = _this.runners.indexOf(task);
            if (index >= 0) {
                _this.runners.splice(index, 1);
            }
            Promise.resolve().then(function () { return _this._loadImages(); });
            _this.completedUrls.add(task.imageUrl);
            if (task.callback) {
                // Call the callback immediately to prevent image-change jitter.
                task.callback(error);
            }
        }; };
        if (this.completedUrls.has(task.imageUrl)) {
            handler()();
            return;
        }
        image.onerror = handler(new Error("Error loading image URL: " + task.imageUrl));
        image.onload = handler();
        image.src = task.imageUrl;
        // eslint-disable-next-line no-param-reassign
        task.imgRef = image;
        this.runners.push(task);
    };
    return ImageQueue;
}());
var queue = new ImageQueue({ maxConnections: 4 });

var UitkQueuedImage = /** @class */ (function (_super) {
    __extends(UitkQueuedImage, _super);
    function UitkQueuedImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            src: undefined
        };
        _this.setImgRef = _this.setImgRef.bind(_this);
        return _this;
    }
    UitkQueuedImage.prototype.UNSAFE_componentWillMount = function () {
        var _a = this.props, serverRender = _a.serverRender, src = _a.src;
        if (serverRender && src) {
            this.setState({ src: src });
        }
    };
    UitkQueuedImage.prototype.componentDidMount = function () {
        var state = this.state;
        var props = this.props;
        var srcFromState = state.src;
        var srcFromProps = props.src;
        if (!srcFromState) {
            this.loadImage(srcFromProps);
        }
    };
    UitkQueuedImage.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var src = this.props.src;
        if (src !== nextProps.src) {
            this.loadImage(nextProps.src);
        }
    };
    UitkQueuedImage.prototype.componentDidUpdate = function (prevProps) {
        var src = this.props.src;
        if (src !== prevProps.src) {
            this.loadImage(src);
        }
    };
    UitkQueuedImage.prototype.componentWillUnmount = function () {
        var _a = this.props, src = _a.src, groupId = _a.groupId;
        queue.dequeue(src, groupId);
    };
    UitkQueuedImage.prototype.setImgRef = function (r) {
        this.imgRef = r;
    };
    UitkQueuedImage.prototype.loadImage = function (src) {
        var _this = this;
        var groupId = this.props.groupId;
        if (src && src.length > 0) {
            queue.enqueue({
                callback: function (err) { return _this.imageDidLoad(err); },
                imageUrl: src,
                imgRef: this.imgRef,
                source: groupId
            });
        }
    };
    UitkQueuedImage.prototype.imageDidLoad = function (error) {
        var _a = this.props, queuedImageFallbackCallback = _a.queuedImageFallbackCallback, src = _a.src;
        if (error && queuedImageFallbackCallback) {
            queuedImageFallbackCallback(this);
        }
        else {
            this.setState({ src: src });
        }
    };
    UitkQueuedImage.prototype.render = function () {
        var _a = this.props, alt = _a.alt, children = _a.children, className = _a.className, useBackgroundImage = _a.useBackgroundImage, ratio = _a.ratio, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        propSrc = _a.src, // This is destructured so it's not passed down as additionalProps
        serverRender = _a.serverRender, serverRenderCallback = _a.serverRenderCallback, loaded = _a.loaded, restOfProps = __rest(_a, ["alt", "children", "className", "useBackgroundImage", "ratio", "src", "serverRender", "serverRenderCallback", "loaded"]);
        var src = this.state.src;
        var additionalProps = __assign({ alt: alt, 'data-loaded': Boolean(src) }, restOfProps);
        if (additionalProps.groupId) {
            delete additionalProps.groupId;
        }
        if (useBackgroundImage) {
            var style = src ? { backgroundImage: "url(" + src + ")" } : {};
            if (serverRender && serverRenderCallback) {
                style = serverRenderCallback(style);
            }
            return (createElement(UitkFigure, { className: className, style: style, ratio: ratio, additionalProps: additionalProps },
                children,
                !src && loaded && createElement(UitkImage, { placeholderImage: true })));
        }
        return (createElement(UitkImage, { imgRef: this.setImgRef, className: className, src: src, alt: alt, additionalProps: additionalProps, placeholderImage: !src }));
    };
    UitkQueuedImage.displayName = 'UitkQueuedImage';
    UitkQueuedImage.defaultProps = {
        useBackgroundImage: false
    };
    return UitkQueuedImage;
}(Component));

var getClassNameList$2 = classNames.bind(styles);
var UitkImageLink = function (_a) {
    var children = _a.children;
    var childrenArray = Children.toArray(children).filter(function (child) { return isValidElement(child); });
    if (childrenArray.length === 0) {
        return null;
    }
    var firstChild = childrenArray[0];
    var className = firstChild.props.className;
    var classList = getClassNameList$2('uitk-image-link', className);
    var clonedElement = cloneElement(firstChild, {
        className: classList
    }, createElement("span", { className: "is-visually-hidden" }, firstChild.props.children));
    return clonedElement;
};
UitkImageLink.displayName = 'UitkImageLink';

export { UitkFigure, UitkFigureAspectRatioType, UitkImage, UitkImageLink, UitkQueuedImage, queue };
